export default Object.freeze({
    GOOGLE_MAPS_API_KEY: 'AIzaSyDsKENV46lY8XMqQJMXiGJ-bXD4Nfsfwmo',
    WINDY: {
        API_KEY: 'w8rsROrDDgeEed8ZtqjqZwL5Z5CbfNeG',
        DEFAULT_LATITUDE: 14,
        DEFAULT_LONGITUDE: -29,
        DEFAULT_ZOOM: 6
    },
    SERVER_URL: '/api',
    LORA_TTN_GATES: '/api/gateway-data',
    LORA_GATE_STATUS: {
        ONLINE: 'online',
        OFFLINE: 'offline'
    },
    GRAPH_TIME_RANGES: {
        0: 12,
        1: 24,
        2: 36,
        3: 48
    },
    HIDE_MAP: 'hide_map',
    EUROPEAN_COUNTRIES: ['cz', 'sk', 'hu', 'pl', 'at', 'de', 'it', 'si', 'ba', 'hr', 'rs', 'ro', 'ua', 'tr', 'gr', 'al', 'mk', 'bg', 'ru', 'by', 'ge', 'az', 'ir'],
    COUNTRIES_COOKIE: 'selected_gateways',
    DEVICE_COLORS: [
        '#FF5252',  // red
        '#448AFF',  // blue
        '#69F0AE',  // green
        '#FFD740',  // amber
        '#E040FB',  // purple
        '#18FFFF',  // cyan
        '#FF6E40',  // deep orange
        '#B388FF',  // deep purple
    ]
});
